<section class="rebook-policy ms-small-b" *ngIf="(rebookAndCancellationPolicies$ | async)?.rebook as rebookPolicy">
  <ng-container
    [ngTemplateOutlet]="policy"
    [ngTemplateOutletContext]="{ policy: rebookPolicy, typeClass: 'rebook-policy' }"
  />
</section>

<section class="cancellation-policy" *ngIf="(rebookAndCancellationPolicies$ | async)?.cancel as cancellationPolicy">
  <ng-container
    [ngTemplateOutlet]="policy"
    [ngTemplateOutletContext]="{ policy: cancellationPolicy, typeClass: 'cancellation-policy' }"
  />
</section>

<ng-template #policy let-policy="policy" let-typeClass="typeClass">
  <h4 class="nordic-blue-900-text font-body-1 ps-medium-b">
    {{ policy.outbound?.label }}
  </h4>
  <p>
    <span class="bound-info block medium-type">
      {{ outbound$ | finMap: 'departure.locationCode' | async }}–{{
        outbound$ | finMap: 'arrival.locationCode' | async
      }}
      ({{ outboundBrandName$ | async }})
    </span>
    <span class="block {{ typeClass }}" [class.heather-700-text]="showHighlightedContent$ | async">
      {{ policy.outbound?.value }}
    </span>
  </p>
  <p *ngIf="(isOneWay$ | async) === false" class="ps-medium-t">
    <span class="bound-info block medium-type">
      {{ inbound$ | finMap: 'departure.locationCode' | async }}–{{
        inbound$ | finMap: 'arrival.locationCode' | async
      }}
      ({{ inboundBrandName$ | async }})
    </span>
    <span class="block" [class.heather-700-text]="showHighlightedContent$ | async">
      {{ policy.inbound?.value }}
    </span>
  </p>
</ng-template>
